import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LanguagePickerPage } from './language-picker.page';

const routes: Routes = [
  {
    path: '',
    component: LanguagePickerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LanguagePickerPageRoutingModule {}
